import { FeatureAnnouncement } from '../../models';

export class LoadFeatureAnnouncements {
  static readonly type = '[Feature Announcements] Load';
}

export class LoadFeatureAnnouncementsSuccess {
  static readonly type = '[Feature Announcements] Load Success';

  constructor(
    public features: FeatureAnnouncement[],
    public authoritative: boolean,
  ) {}
}

export class LoadFeatureAnnouncementsFail {
  static readonly type = '[Feature Announcements] Load Fail';
}

export class MarkFeatureAnnouncementSeen {
  static readonly type = '[Feature Announcements] Mark Seen';

  constructor(
    public featureKey: string,
    public tourCompleted = false,
  ) {}
}

export class MarkAllFeatureAnnouncementsSeen {
  static readonly type = '[Feature Announcements] Mark All Seen';
}
